const isFileNamePdf = ({ fileName }) => {
    if (String(fileName).toLocaleLowerCase().slice(-4) === ".pdf") {
        return true;
    } else {
        return false;
    }
};

export { isFileNamePdf };
